import { resolveConfig } from 'prettier';
import { resolvePath } from 'react-router-dom';

type ExtensionInfo = overwolfInternal.extensions.ExtensionInfo;

// -----------------------------------------------------------------------------
export class OWInternalExtensions {
  // ---------------------------------------------------------------------------
  public static getDownloadedExtensions(): Promise<ExtensionInfo[]> {
    return new Promise((resolve) => {
      overwolfInternal.extensions.getDownloadedExtensions((result) => {
        if (result?.status === 'error') {
          console.error(`Failed to get all open windows: ${result.reason}`);
        }

        return resolve(result?.extensions || []);
      });
    });
  }

  // ---------------------------------------------------------------------------
  public static showDevTools(extensionId: string, windowName: string) {
    overwolfInternal.extensions.showDevTools(extensionId, windowName);
  }

  // ---------------------------------------------------------------------------
  public static installAnyApp(appId: string, requireLogin = false) {
    return new Promise((resolve) => {
      overwolfInternal.extensions.installAnyApp(
        appId,
        requireLogin,
        (result) => {
          if (result.status === 'error') {
            console.error(`Failed to install app: ${result.reason}`);
          }

          return resolve(result);
        },
      );
    });
  }

  // ---------------------------------------------------------------------------
  public static changeExtensionEnableState(uid: string, enable: boolean) {
    return new Promise((resolve) => {
      overwolfInternal.extensions.changeExtensionEnableState(
        uid,
        enable,
        (result) => {
          if (!result.success) {
            console.error(
              `Failed to change enable state for ${uid} to ${enable}`,
            );
          }

          return resolve(result);
        },
      );
    });
  }

  // ---------------------------------------------------------------------------
  public static addTemporarilyWhitelistedExtension(uid: string) {
    return new Promise((resolve) => {
      overwolfInternal.extensions.addTemporarilyWhitelistedExtension(
        uid,
        (result) => {
          if (result.status !== 'success') {
            console.error(
              `Failed to addTemporarilyWhitelistedExtension ${uid} `,
            );
          }

          return resolve(result);
        },
      );
    });
  }
}
